module.exports = __webpack_public_path__ + "img/b.1e601e04.png";